import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useAppStore = defineStore('app', () => {
  const isSidebarOpen = ref(true)
  const theme = ref<'light' | 'dark'>('light')

  function toggleSidebar() {
    isSidebarOpen.value = !isSidebarOpen.value
  }

  function setTheme(newTheme: 'light' | 'dark') {
    theme.value = newTheme
    if (newTheme === 'dark') {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  return {
    isSidebarOpen,
    theme,
    toggleSidebar,
    setTheme
  }
})
